import { toast } from 'react-toastify';

import { isArray } from 'lodash';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
  successRemoveForm,
} from './actions';

export function* requestOperacaoTransferencias({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'movimentacoestransferencias', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* deleteOperacaoTransferencia({ payload }) {
  try {
    const { id, params, query } = payload;

    yield call(api.delete, `movimentacoestransferencias/${id}`, {
      params: query,
    });
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* store({ payload }) {
  try {
    const { operacaotransferencia, params } = payload;

    yield call(api.post, 'movimentacoestransferencias', operacaotransferencia);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/operacaotransferencia');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* find({ payload }) {
  try {
    const { id } = payload;

    const { data } = yield call(api.get, `movimentacoestransferencias/${id}`);

    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* update({ payload }) {
  try {
    const { operacaotransferencia, params } = payload;

    yield call(api.put, 'movimentacoestransferencias', operacaotransferencia);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/operacaotransferencia');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'movimentacoestransferencias', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* applyUpdate({ payload }) {
  try {
    const { data, params } = payload;

    yield call(api.put, 'movimentacoestransferencias/altera', data);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/operacaotransferencia');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* deletarCliente({ payload }) {
  try {
    const { operacaotransferencia, params } = payload;

    let idoperacaoabastecimento = '';

    idoperacaoabastecimento = operacaotransferencia.idmovimentacao;
    idoperacaoabastecimento = `${idoperacaoabastecimento}/${operacaotransferencia.idposto}`;

    const justificativa = operacaotransferencia.justificativa || '';

    const obj = {};
    obj.justificativa = justificativa;

    yield call(
      api.delete,
      `movimentacoestransferencias/${idoperacaoabastecimento}`,
      { params: obj }
    );
    yield put(successRemoveForm({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
    history.push('/operacaotransferencia');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export default all([
  takeLatest(
    '@operacaotransferencia/OPERACAOTRANSFERENCIAS_IN_REQUEST',
    requestOperacaoTransferencias
  ),
  takeLatest(
    '@operacaotransferencia/DELETE_OPERACAOTRANSFERENCIA',
    deleteOperacaoTransferencia
  ),
  takeLatest(
    '@operacaotransferencia/SUCCESS_REMOVE',
    requestOperacaoTransferencias
  ),
  takeLatest(
    '@operacaotransferencia/SUCCESS_REMOVE_FORM',
    requestOperacaoTransferencias
  ),
  takeLatest('@operacaotransferencia/STORE_OPERACAOTRANSFERENCIA', store),
  takeLatest('@operacaotransferencia/FIND_OPERACAOTRANSFERENCIA', find),
  takeLatest('@operacaotransferencia/UPDATE_OPERACAOTRANSFERENCIA', update),
  takeLatest('@operacaotransferencia/RECORD_FILTERING', applyedFilters),
  takeLatest('@operacaotransferencia/UPDATE', applyUpdate),
  takeLatest(
    '@operacaotransferencia/DELETE_OPERACAOTRANSFERENCIA_CLIENTE',
    deletarCliente
  ),
]);
